import { render, staticRenderFns } from "./ad-copy.vue?vue&type=template&id=46ac392b&scoped=true&"
import script from "./ad-copy.vue?vue&type=script&lang=js&"
export * from "./ad-copy.vue?vue&type=script&lang=js&"
import style0 from "./ad-copy.vue?vue&type=style&index=0&id=46ac392b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ac392b",
  null
  
)

export default component.exports